









import {
  computed,
  defineComponent,
  reactive,
  inject,
  watchEffect,
} from '@vue/composition-api'
import { OemJsonType } from '@/@types/common'

type StateType = {
  oemInfo: OemJsonType | null
}

export default defineComponent({
  props: {
    id: {
      type: String,
      required: false,
      default: '',
    },
    text: {
      type: String,
      required: true,
    },
    path: {
      type: String,
      required: false,
      default: '',
    }
  },
  setup(props) {
    const state: StateType = reactive({
      oemInfo: null,
    })

    const oemInfo = inject<{
      value: OemJsonType
    } | null>('$oemInfo', null)

    watchEffect(() => {
      if (oemInfo) {
        state.oemInfo = oemInfo.value
      }
    })

    const link = computed(() => {
      if (state.oemInfo) {
        return `${process.env.VUE_APP_MANUAL_URL}?o=${state.oemInfo.oemValue}#${props.id}`
      } else if(props.path !== '' ) {
        return `${process.env.VUE_APP_MANUAL_URL}${props.path}/#${props.id}`
      } else {
        return `${process.env.VUE_APP_MANUAL_URL}#${props.id}`
      }
    })

    return {
      link,
    }
  },
})
